<div class="lp-own-products-header">
  <div class="lp-own-products-header__wrapper">
    <button
      tuiIconButton
      type="button"
      [appearance]="isDesktop ? 'secondary' : 'icon'"
      [size]="isDesktop ? 'l' : 'm'"
      iconStart="@tui.chevron-left"
      [routerLink]="'/loyalty'"
    ></button>

    <div class="title">
      <h1>{{ title }}</h1>
    </div>

    <lp-statistics-button *ngIf="allowAllStatisticsViewing" [routerLink]="'/loyalty/statistics'"></lp-statistics-button>

    <lp-add-button *ngIf="allowCreating" (buttonClick)="add.emit()"></lp-add-button>
  </div>
</div>
